import { createSelector } from 'reselect'
import { get } from 'lodash/fp'

export const getSaleFlow = createSelector(get('portal.saleFlow'), (saleFlow) => saleFlow)
export const isFNAFlow = createSelector(get('portal.saleFlow'), (saleFlow) => saleFlow === 'fna')
export const isQQFlow = createSelector(get('portal.saleFlow'), (saleFlow) => saleFlow === 'quick-quote')
